export enum ProviderName {
  TELNYX_TOLL_FREE = 'Telnyx',
  TELNYX_10DLC = 'Telnyx 10DLC',
  SINCH_10DLC = 'Sinch 10DLC',
  SINCH_SHORT_CODE = 'Sinch Short Code',
  BANDWIDTH_TOLL_FREE = 'Bandwidth',
  BANDWIDTH_10DLC = 'Bandwidth 10DLC',
}